import { CUSTOMER_FEEDBACK } from './types';

export const submitCustomerFeedback = payload => ({
  type: CUSTOMER_FEEDBACK,
  payload,
});
